export interface AssessmentUnitLabels {
  singular: string;
  plural: string;
  titleSingular: string;
  titlePlural: string;
}

const EN_LABELS: Record<string, AssessmentUnitLabels> = {
  control: { singular: 'control', plural: 'controls', titleSingular: 'Control', titlePlural: 'Controls' },
  clause: { singular: 'clause', plural: 'clauses', titleSingular: 'Clause', titlePlural: 'Clauses' },
  measure: { singular: 'measure', plural: 'measures', titleSingular: 'Measure', titlePlural: 'Measures' },
  requirement: { singular: 'requirement', plural: 'requirements', titleSingular: 'Requirement', titlePlural: 'Requirements' },
  criterion: { singular: 'criterion', plural: 'criteria', titleSingular: 'Criterion', titlePlural: 'Criteria' },
  function: { singular: 'function', plural: 'functions', titleSingular: 'Function', titlePlural: 'Functions' },
  article: { singular: 'article', plural: 'articles', titleSingular: 'Article', titlePlural: 'Articles' },
  section: { singular: 'section', plural: 'sections', titleSingular: 'Section', titlePlural: 'Sections' },
};

const AR_LABELS: Record<string, AssessmentUnitLabels> = {
  control: { singular: 'ضابط', plural: 'ضوابط', titleSingular: 'ضابط', titlePlural: 'ضوابط' },
  clause: { singular: 'بند', plural: 'بنود', titleSingular: 'بند', titlePlural: 'بنود' },
  measure: { singular: 'مقياس', plural: 'مقاييس', titleSingular: 'مقياس', titlePlural: 'مقاييس' },
  requirement: { singular: 'متطلب', plural: 'متطلبات', titleSingular: 'متطلب', titlePlural: 'متطلبات' },
  criterion: { singular: 'معيار', plural: 'معايير', titleSingular: 'معيار', titlePlural: 'معايير' },
  function: { singular: 'وظيفة', plural: 'وظائف', titleSingular: 'وظيفة', titlePlural: 'وظائف' },
  article: { singular: 'مادة', plural: 'مواد', titleSingular: 'مادة', titlePlural: 'مواد' },
  section: { singular: 'قسم', plural: 'أقسام', titleSingular: 'قسم', titlePlural: 'أقسام' },
};

const resolveBaseUnit = (standardType?: string | null, sectionIds: string[] = []): string => {
  const standard = (standardType || '').toLowerCase();
  const ids = sectionIds.filter(Boolean).map((id) => String(id));

  if (standard.startsWith('sumud')) return 'measure';
  if (standard.startsWith('nist')) return 'function';
  if (standard.startsWith('soc2')) return 'criterion';
  if (standard.startsWith('gdpr')) return 'article';
  if (standard.startsWith('pci')) return 'requirement';
  if (standard.startsWith('dga')) return 'control';
  if (standard.startsWith('iso27001')) {
    const hasControl = ids.some((id) => id.startsWith('A.'));
    const hasClause = ids.some((id) => /^\d/.test(id));
    if (hasControl && !hasClause) return 'control';
    if (hasClause && !hasControl) return 'clause';
    return 'section';
  }
  return 'section';
};

export const getAssessmentUnitLabels = (
  standardType?: string | null,
  sectionIds: string[] = [],
  language = 'en'
): AssessmentUnitLabels => {
  const baseUnit = resolveBaseUnit(standardType, sectionIds);
  const labels = language.toLowerCase().startsWith('ar') ? AR_LABELS[baseUnit] : EN_LABELS[baseUnit];
  return labels || EN_LABELS.section;
};

